import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "../auth.service";

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private _auth: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
  
    if (!req.url.includes("oauth") && this._auth.isLogged()) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${
            this._auth.user.getSessionData().accessToken
          }`,
          userToken: this._auth.user.getSessionData().userIdToken,
          sessionId: this._auth.user.getSessionData().userIdToken,
          
        },
      });
    }
    return next.handle(req);
  }
}
